import { format } from 'date-fns';

/** Short time label, e.g. "9:00 AM". */
export function formatTime(date: Date): string {
	return format(date, 'h:mm a');
}
